import { render, staticRenderFns } from "./TumourDrugManager.vue?vue&type=template&id=d3522706&scoped=true&"
import script from "./TumourDrugManager.vue?vue&type=script&lang=js&"
export * from "./TumourDrugManager.vue?vue&type=script&lang=js&"
import style0 from "./TumourDrugManager.vue?vue&type=style&index=0&id=d3522706&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3522706",
  null
  
)

export default component.exports